
import { useEffect } from 'react';
import { supabase } from "@/integrations/supabase/client";

export const useStockItemsRealtime = (
  stockId: string | undefined,
  onUpdate: (updatedData: any[]) => void
) => {
  useEffect(() => {
    if (!stockId) return;

    console.log("Setting up realtime subscription for stock items");
    
    const channel = supabase
      .channel('stock-changes')
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'stock_items',
          filter: `stock_id=eq.${stockId}`
        },
        async (payload) => {
          console.log("Received realtime update:", payload);
          
          // Récupérer tous les stocks de l'utilisateur actuel
          const { data: { user } } = await supabase.auth.getUser();
          if (!user) return;

          const { data: businessStocks, error: stockError } = await supabase
            .from('business_stocks')
            .select('id')
            .eq('owner_id', user.id);

          if (stockError || !businessStocks) {
            console.error("Error fetching business stocks:", stockError);
            return;
          }

          // Récupérer les articles de tous les stocks
          let allItems = [];
          for (const stock of businessStocks) {
            const { data: items, error: itemsError } = await supabase
              .from('stock_items')
              .select('*')
              .eq('stock_id', stock.id);

            if (itemsError) {
              console.error("Error fetching items for stock:", stock.id, itemsError);
              continue;
            }

            if (items) {
              allItems = [...allItems, ...items];
            }
          }

          console.log("Updated items:", allItems);
          onUpdate(allItems || []);
        }
      )
      .subscribe((status) => {
        console.log("Subscription status:", status);
      });

    return () => {
      console.log("Cleaning up realtime subscription");
      supabase.removeChannel(channel);
    };
  }, [stockId, onUpdate]);
};
